import {Address} from '../address/address.model';
import {CrudModel} from '@ngx-ivengi/crud';
import {Owner} from '../owner/owner.model';

export class Building extends CrudModel {

  public buildingId: string; // Used for building links
  public name: string;
  public address: Address = new Address();
  public ownerId: string;
  public owner: Owner = new Owner();
  public legacyDrawing: FileList;
  public legacyDrawingId: string;
  public legacyDrawingSrc: string;
  public legacyDrawingName: string;
  public notesFile: FileList;
  public notesFileId: string;
  public notesFileSrc: string;
  public notesFileName: string;
  public inAssignments: number;

  public setBuildingId(buildingId: string): Building {
    if(typeof buildingId === 'string') {
      this.buildingId = buildingId;
    }
    return this;
  }

  public setName(name: string): Building {
    if(typeof name === 'string') {
      this.name = name;
    }
    return this;
  }

  public setOwnerId(ownerId: string): Building {
    if(typeof ownerId === 'string') {
      this.ownerId = ownerId;
    }
    return this;
  }

  public setAddress(address: Address): Building {
    if(address instanceof Address) {
      this.address = address;
    }
    return this;
  }

  public setLegacyDrawing(files: FileList): Building {
    if(files instanceof FileList) {
      this.legacyDrawing = files;
    }
    return this;
  }

  public setLegacyDrawingId(id: string): Building {
    if(typeof id === 'string') {
      this.legacyDrawingId = id;
    }
    return this;
  }

  public setLegacyDrawingSrc(src: string): Building {
    if(typeof src === 'string') {
      this.legacyDrawingSrc = src;
    }
    return this;
  }

  public setLegacyDrawingName(name: string): Building {
    if(typeof name === 'string') {
      this.legacyDrawingName = name;
    }
    return this;
  }

  public setNotesFile(files: FileList): Building {
    if(files instanceof FileList) {
      this.notesFile = files;
    }
    return this;
  }

  public setNotesFileId(id: string): Building {
    if(typeof id === 'string') {
      this.notesFileId = id;
    }
    return this;
  }

  public setNotesFileSrc(src: string): Building {
    if(typeof src === 'string') {
      this.notesFileSrc = src;
    }
    return this;
  }

  public setNotesFileName(name: string): Building {
    if(typeof name === 'string') {
      this.notesFileName = name;
    }
    return this;
  }
  public setInAssignments(count: number): Building {
    if(typeof count === 'number') {
      this.inAssignments = count;
    }
    return this;
  }

  fromResponse(response: any): void {

    // First set id. Whether it is an entity or a link
    this
      .setId(response.id)
      .setBuildingId(response.id);

    if(typeof response.building === 'object') {
      this.setBuildingId(response.building.id);
      response = response.building;
    }

    this
      .setName(response.name)
      .setOwnerId(response.ownerId)
      .setBuildingId(response.id)
      .setLegacyDrawingId(response.legacyDrawingId)
      .setNotesFileId(response.notesFileId)
      .setInAssignments(response.inAssignments);

    if(response.legacyDrawing) {
      this
        .setLegacyDrawing(response.legacyDrawing)
        .setLegacyDrawingName(response.legacyDrawing.name);
    }

    if(response.notesFile) {
      this
        .setNotesFile(response.notesFile)
        .setNotesFileName(response.notesFile.name);
    }

    if(response.owner) {
      this.owner
        .setName(response.owner.name);
    }

    if(response.address) {
      this.address
        .setAddress(response.address.address)
        .setZip(response.address.zip)
        .setCity(response.address.city)
        .setCountry(response.address.country);
    }
  }
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/building/building.model.ts